export default "https://cdn-static-staging.gokick.com/assets/ec0de4ab37568b9a2e84c5fbf7dadc9a5c7c6fae/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";